'use strict';Object.defineProperty(exports,'__esModule',{value:!0});exports.default=function(){for(var _len=arguments.length,a=Array(_len),_key=0;_key<_len;_key++)a[_key]=arguments[_key];return a.filter(function(b){return!!b}).join(' ')};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-tab-panel/lib/join.js
 ** module id = 137
 ** module chunks = 0
 **/